module.exports = __webpack_public_path__ + "static/img/caren-dribbble.06dda32.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/caren-dribbble.gif
// module id = A54u
// module chunks = 0